<div  md-dialog-content >
  <!-- <p class="popupalign"><b>{{confirmMessage}}</b></p></div> -->
<!-- <div md-dialog-content *ngIf="displaygrid"><p>welcome</p><br>
<p>Welcome2</p></div> -->
{{confirmMessage}}
</div><br><br><br>
<div md-dialog-actions>

  <button mat-flat-button class="custom-modal"  (click)="dialogRef.close(true)">OK</button>
</div>